export default {
    init() {

        let becomeMember = jQuery(".becomeMember");

        if (becomeMember.length)
        {
            setTimeout(() => {
                $('body,html').animate({
                    scrollTop: $("#memberForm").offset().top - 200
                }, 2000, () => {
                    $('div.wpcf7 > form').wpcf7ResizeSignatures();
                });  
            }, 300);
        }

      
        $(window).resize(function(){
            $('div.wpcf7 > form').wpcf7ResizeSignatures();
        });

        $('.membership-type input[type=radio]').change(function() {
            if ($(this).val() === 'Membership RENEWAL') {
                $(".member-form #member-renewal").show();
            } else {
                $(".member-form #member-renewal").hide();
            }
        })


        /*jQuery( ".subtabheader .title" ).click(function() {
            let id = jQuery(this).data('id');

            

            jQuery('.subtabheader .title').each(function () { 
                jQuery(this).removeClass("active");
            });
            
            if (id === undefined)
            {
                return;
            }
            
            jQuery(this).addClass("active");

            let content = jQuery(`#contentBlock .subtab[data-id='${id}']`);

            if (!content)
            {
                return;
            }

            if (content.hasClass("active"))
            {
                return;
            }


            jQuery('#contentBlock .subtab').each(function () { 
                jQuery(this).removeClass("active");
            });

            content.addClass("active");

        });*/
      
      
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/donate.js